/**
 * Component Entry
 *
 */

import Switch from './Switch'
export default Switch
export * from './Switch'
